import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaMapMarkerAlt } from 'react-icons/fa';
import { assetUrl } from '../utils';

const PublicListingCard = ({ listing, href, label }) => {
  const rentFacts = listing.rentDetails || {};
  const propertyFacts = listing.propertyDetails || {};
  const teaser =
    listing.listingType === 'rent'
      ? rentFacts.propertyType || rentFacts.propertySubtype || rentFacts.buildingSize
      : propertyFacts.mlsNumber || propertyFacts.propertyType || propertyFacts.county;

  return (
    <article className="relative group overflow-hidden rounded-[18px] border border-[#262626] bg-[#111] transition-all duration-300 hover:-translate-y-1 hover:border-[#EEC24B]">
      <div className="relative h-[240px] overflow-hidden bg-[#1A1A1A] sm:h-[300px]">
        <img
          src={assetUrl(listing.mainImage)}
          alt={listing.title}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/15 to-transparent" />
        {listing.featured && (
          <span className="absolute right-[1rem] top-[1rem] rounded-full border border-white/20 bg-black/60 px-[0.8rem] py-[0.35rem] text-[12px] font-semibold uppercase tracking-[0.12em] text-white">
            Featured
          </span>
        )}
      </div>

      <div className="absolute left-0 top-0 flex h-full w-full flex-col justify-end gap-[0.9rem] bg-gradient-to-b from-transparent to-black/90 p-4 opacity-100 transition-opacity duration-300 sm:p-5 sm:opacity-0 sm:group-hover:opacity-100">
        <div className="flex items-center gap-[0.5rem] text-[#EEC24B]">
          <FaMapMarkerAlt size={14} />
          <span className="text-[13px] font-semibold uppercase tracking-[0.16em]">{label}</span>
        </div>
        <h3 className="text-[22px] font-bold leading-tight text-white">{listing.title}</h3>
        {/* <p className="line-clamp-3 text-[15px] font-light leading-relaxed text-[#BDBDBD]">
          {listing.summary || listing.description}
        </p> */}

        {teaser ? (
          <div className="rounded-lg border border-[#262626] bg-[#756e6e40] px-[1rem] py-[0.8rem]">
            <p className="text-[12px] uppercase tracking-[0.14em] text-[#999]">Primary detail</p>
            <p className="mt-[0.15rem] text-[15px] font-semibold text-white">{teaser}</p>
          </div>
        ) : null}

        <div className="flex items-center justify-between gap-[1rem] pt-[0.15rem]">
          <Link
            to={href}
            className="inline-flex items-center gap-[0.5rem] text-[15px] font-semibold text-white transition-colors duration-300 group-hover:text-[#EEC24B]"
          >
            View details
            <FaArrowRight size={14} />
          </Link>
          {listing.externalUrl ? (
            <a
              href={listing.externalUrl}
              target="_blank"
              rel="noreferrer"
              className="text-[14px] font-medium text-[#999] transition-colors duration-300 hover:text-[#EEC24B]"
            >
              {listing.listingType === 'rent' ? 'Loopnet' : 'MLS'}
            </a>
          ) : null}
        </div>
      </div>
    </article>
  );
};

export default PublicListingCard;
